import { useAuth } from "@/api/hooks/useAuth"
import { useNavigate } from "@tanstack/react-router"
import { Card } from "primereact/card"

const Welcome = () => {
  const { user } = useAuth()
  return (
    <Card className="shadow-3 border-round mb-3">
      <div className="flex flex-column">
        <h1 className="text-2xl font-medium mb-3">ダッシュボード</h1>
        <p className="mb-0">
          ようこそ、
          <span className="font-bold">
            {user?.display_name ?? 'ユーザー'}
          </span>{' '}
          さん！アプリケーションの機能を利用するには、下記のオプションからお選びください。
        </p>
      </div>
    </Card>
  )
}
export default Welcome
